/** Shared formatter helpers for the Audit panel. */
export const pct = (v: number | null) => v === null ? '—' : `${(v * 100).toFixed(1)}%`;
export const r2  = (v: number | null) => v === null ? '—' : `${v >= 0 ? '+' : ''}${v.toFixed(2)}R`;
export const colorR = (v: number | null): string =>
  v === null ? 'var(--t3)' : v > 0 ? 'var(--green)' : v < 0 ? 'var(--red)' : 'var(--t2)';
export const colorWR = (v: number | null): string =>
  v === null ? 'var(--t3)' : v >= 0.55 ? 'var(--green)' : v >= 0.45 ? 'var(--amber)' : 'var(--red)';

// v5 Intelligence view formatters
export const rFmt = (v: number | null) => v === null ? '—' : `${v >= 0 ? '+' : ''}${v.toFixed(2)}R`;
export const pFmt = (v: number | null) => v === null ? '—' : `${(v * 100).toFixed(1)}%`;
export const nFmt = (v: number | null) => v === null ? '—' : v.toFixed(0);
